import ScoreTypeRepositoryInterface, { ScoreTypeInterface } from '@/services/QA/scoreType/interfaces';
import { AxiosInstance } from 'axios';

export default class ScoreTypeRepository implements ScoreTypeRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async createScoreType(data: Partial<ScoreTypeInterface>): Promise<ScoreTypeInterface> {
    const res = await this.axios.post('/qa-controller/scoreTypes', data);

    return res.data
  }

  public async editScoreType(id: number, data: Partial<ScoreTypeInterface>): Promise<void> {
    await this.axios.patch(`/qa-controller/scoreTypes/${id}`, data);
  }

  public async getOneById(id: number): Promise<ScoreTypeInterface> {
    const res = await this.axios.get(`/qa-controller/scoreTypes/${id}`);

    return res.data
  }

  public async getAllScoreTypes(): Promise<ScoreTypeInterface[]> {
    const res = await this.axios.get('/qa-controller/scoreTypes');

    return res.data
  }
}
